import React from 'react';
import { useData } from '../DataProviderContext';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';

// This component displays the current state of the data in a card format

const DataStateDisplay = () => {
    const { dataState } = useData();

    const renderCard = (title, content) => (
        <Card sx={{ minWidth: 275, marginBottom: 2 }}>
            <CardContent>
                <Typography variant="h5" component="div">
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {content}
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <Box sx={{ padding: 2 }}>
            <Typography variant="h4" gutterBottom>
                Data State
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                    {renderCard('AuthToken', dataState.authToken)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Error', dataState.error)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('DB State', dataState.dbState)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Data Loaded', dataState.dataLoaded.toString())}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Storage Status', dataState.storageStatus)}
                </Grid>
                
                <Grid item xs={12} sm={2}>
                    {renderCard('User Document', JSON.stringify(dataState.userDocument, null, 2))}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('User Pad', JSON.stringify(dataState.userPad, null, 2))}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Selected Node', dataState.selectedNode)}
                </Grid>
                <Grid item xs={12} sm={4}>
                    {renderCard('Selected Node content', dataState.selectedNodeContent)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Selected Step', dataState.selectedStep)}
                </Grid>
                <Grid item xs={12} sm={3}>
                    {renderCard('Is Empty', dataState.isEmpty.toString())}
                </Grid>
                <Grid item xs={12} sm={3}>
                    {renderCard('Show Alert', dataState.showAlert.toString())}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('Alert Message', dataState.alertMessage)}
                </Grid>
                <Grid item xs={12} sm={2}>
                    {renderCard('DispatcherAction', JSON.stringify(dataState.dispatcherAction, null, 2))}
                </Grid>
                <Grid item xs={12} sm={8}>
                    {renderCard('User Docs', JSON.stringify(dataState.userDocs, null, 2))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default DataStateDisplay;
